import { useEffect, useState } from "react";

// Otis Admin PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import BookingCard from "examples/Cards/BookingCard";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
// Images
import trans1 from "assets/images/Synchro/trans1.jpeg";
import trans2 from "assets/images/Synchro/trans2.jpeg";
import trans3 from "assets/images/Synchro/trans3.jpeg";


function LandingLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOpen = () => {
    // console.log("Navigating to MapCreateEvent with formData:", formData);
    navigate("/dashboards/junctions");
  };

    //const [dropItems, setDropItems] = useState(null); // State for selected event
    // useEffect(() => {    
    //     setDropItems(filter.dataSourceMapping);
    // }, []);
    
    return (
        <div style={{ padding: "30px" }}>
            <Card>
                <MDBox p={3} lineHeight={1} textAlign="center">
                    <MDTypography variant="h1" fontWeight="medium">
                        FLYOVER - RCM
                    </MDTypography>
                </MDBox>
            </Card>
            <Grid container spacing={3} marginTop={"20px"}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mt={3}>
                <BookingCard
                  image={trans1}
                  title={t("landing.tools.tool1.title")}
                  description={t("landing.tools.tool1.description")}
                  price=""
                  location={t("landing.tools.tool1.location")}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mt={3}>
                <BookingCard
                  image={trans2}
                  title={t("landing.tools.tool2.title")}
                  description={t("landing.tools.tool2.description")}
                  price=""
                  location={t("landing.tools.tool2.location")}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mt={3}>
                <BookingCard
                  image={trans3}
                  title={t("landing.tools.tool3.title")}
                  description={t("landing.tools.tool3.description")}
                  price=""
                  location={t("landing.tools.tool3.location")}
                />
              </MDBox>
            </Grid>
          </Grid>
          <Grid container spacing={3} marginTop={"20px"}>
          <Grid item xs={12} md={6} lg={4}>
          <MDBox mt={3}>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
          <MDBox mt={3} display="flex" justifyContent="center"> 
          <MDButton variant="contained" color="info" onClick={handleOpen}>{t("landing.login")}
          </MDButton>
            
             </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
          <MDBox mt={3}></MDBox>
          </Grid>
                      
            </Grid>
        </div>
    );
}

export default LandingLayout;